import React from 'react';
import styles from 'Custom/Question/index.module.scss';
import RichText from 'Custom/RichText';

import QuestionIcon from 'Images/brand-icons/question-icon.svg';

const WRAPPER_DIRECTION = {
  column: styles.column,
  row: styles.row,
  default: styles.column,
};

const WRAPPER_SIZE = {
  large: styles.large,
  small: styles.small,
  default: styles.small,
};

const TITLE_SIZE = {
  large: styles.titleLarge,
  small: styles.titleSmall,
  default: styles.titleSmall,
};

const Question = ({
  question = [],
  direction = 'column',
  size = 'small',
  titSize = 'small',
}) => {
  const wrapperDirection =
    WRAPPER_DIRECTION[direction] || WRAPPER_DIRECTION.default;
  const wrapperSize = WRAPPER_SIZE[size] || WRAPPER_SIZE.default;
  const titleSize = TITLE_SIZE[titSize] || TITLE_SIZE.default;

  return (
    <>
      {question.map((item, index) => {
        const { questionTitle: itemTitle, questionContent: itemContent } = item;

        return (
          <div
            className={`${styles.questionWrapper} ${wrapperDirection} ${wrapperSize}`}
            key={index}
          >
            <div className={`${styles.title}`}>
              <QuestionIcon />
              <RichText>
                <h3 className={`${titleSize}`}>{itemTitle}</h3>
              </RichText>
            </div>
            <div className={`${styles.content}`}>
              <RichText>{itemContent}</RichText>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Question;
